import { Banners } from '@core/models/interfaces/storage-data/banners';
import { createActionGroup, props } from '@ngrx/store';

export const BannersActions = createActionGroup({
  source: 'Banners',
  events: {
    'Load Banners Success': props<{ banners: Banners }>(),
  },
});
